import {Favorites} from "../Favorites";
import {Fast} from "../Card/Fast";

class Catalog {
    static infiniteScrollObserver = null;

    static load(page, data, callback) {
        if (!page || page.length <= 0) {
            return;
        }

        $.ajax({
            url: page,
            data: data,
            timeout: 10000,
            success: function (result) {
                callback(!result || !result.length ? false : $(result));
            },
            error: function (jqXHR, textStatus, errorThrown) {
                callback(false);
            }
        });
    }

    static initInfiniteScroll() {
        if (this.infiniteScrollObserver) {
            this.infiniteScrollObserver.disconnect();
        }

        let $loadMoreBtn = $('.js-products .replaceable [data-url]');
        if (!$loadMoreBtn.length) {
            return;
        }

        this.infiniteScrollObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let $btn = $(entry.target);

                    if (!$btn.prop('disabled')) {
                        $btn.trigger('click');
                    }
                }
            });
        }, {
            root: null,
            rootMargin: '200px',
            threshold: 0
        });

        this.infiniteScrollObserver.observe($loadMoreBtn[0]);
    }
    
    static isBackNavigation() {
        if (window.performance) {
            let navEntries = performance.getEntriesByType('navigation');
            if (navEntries.length > 0) {
                return navEntries[0].type === 'back_forward';
            }

            // Fallback for older browsers
            if (performance.navigation) {
                return performance.navigation.type === 2;
            }
        }
        return false;
    }

    static scrollToLastViewedProduct() {
        let productId = sessionStorage.getItem('lastViewedProduct');

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        
        if (!productId) {
            return;
        }
        
        if (this.isBackNavigation()) {
            let $product = $(`.js-section_product[data-product="${productId}"]`);
            
            if ($product.length) {
                window.scrollTo(0, $product.offset().top - 100);
            }
        }
        
        sessionStorage.removeItem('lastViewedProduct');
    }

    static bindFavorites() {
        new Favorites();

        $('.js-favorites_add').off('mario.favorites.added').on('mario.favorites.added', (event) => {
            $(event.currentTarget).addClass('active');

            Catalog.bindFavorites();
        });

        $('.js-favorites_remove').off('mario.favorites.removed').on('mario.favorites.removed', (event) => {
            $(event.currentTarget).removeClass('active');

            Catalog.bindFavorites();
        });
    }

    static bindFast() {
        $('.js-catalog_card-fast').bindToEntity(Fast);
    }

    static catalogReloadCallback(result) {
        $('body').preloader('hide');
        if (result !== false) {
            $('.js-products')
                .html(result.find('.js-products').html())
                .trigger('mario.catalog.reloaded', [result.find('.js-products')]);
        }
    }
}

export default Catalog;